import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import EnLanguageProvider from '@/components/en/EnLanguageProvider';
import OnDemandChat from '@/components/agent/OnDemandChat';
import applyPageMetadata from '@/components/seo/pageMetadata';
import englishPageMetadata from '@/components/en/englishPageMetadata';
import { isPrivateRoute } from '@/components/seo/PrivateRouteMetadata';
import SiteHeader from '@/components/redesign/SiteHeader';
import SiteFooter from '@/components/redesign/SiteFooter';
import '@/components/redesign/redesign.css';
const EN_NOINDEX_PATHS = ['/en/service-agreement', '/en/app-guide'];
export default function EnLayout() {
  const { pathname } = useLocation();
  const checkout = pathname === '/en/ny-checkout';
  const hideAssistant = checkout || pathname === '/en/support';
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  useEffect(() => {
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) { robots = document.createElement('meta'); robots.name = 'robots'; document.head.appendChild(robots); }
    robots.content = isPrivateRoute(pathname) ? 'noindex, nofollow' : EN_NOINDEX_PATHS.includes(pathname) ? 'noindex, follow' : 'index, follow';
    document.documentElement.lang = 'en';
    let active = true;
    applyPageMetadata(englishPageMetadata(pathname));
    if (pathname.toLowerCase().startsWith('/en/blog/')) {
      import('@/components/en/blog/enBlogData').then(({ getEnArticleBySlug }) => {
        if (active) applyPageMetadata(englishPageMetadata(pathname, getEnArticleBySlug(pathname.replace(/\/$/, '').split('/').pop())));
      });
    }
    return () => { active = false; robots.content = 'index, follow'; };
  }, [pathname]);
  return <EnLanguageProvider><div className="ee-site min-h-screen flex flex-col">
    <SiteHeader en checkout={checkout} />
    <main id="site-main" className="flex-1" tabIndex={-1}><Outlet /></main>
    <SiteFooter en compact={checkout} />
    {!hideAssistant && <OnDemandChat en />}
  </div></EnLanguageProvider>;
}